import { FilterType, FilterOption, FilterModel } from './filter.utils';

export function textFilter(row: any, filterModel: FilterModel): boolean {
  let rowValue = row[filterModel.colId];
  const type = filterModel.type;

  if (rowValue === null || rowValue === undefined) {
    return false;
  }

  if (!filterModel.caseSensitive) {
    rowValue = rowValue.toLowerCase();
    filterModel.filter = String(filterModel.filter).toLowerCase();
  }

  if (type === FilterOption.Contains) {
    return rowValue.indexOf(filterModel.filter) > -1;
  } else if (type === FilterOption.Equals) {
    return rowValue === filterModel.filter;
  } else if (type === FilterOption.StartsWith) {
    return rowValue.startsWith(filterModel.filter);
  }

  return false;
}
export function filterGrid(data: any[], filterModel: FilterModel[]): any[] {
  filterModel.forEach((currentFilterModel) => {
    if (
      currentFilterModel.filterType === FilterType.Text ||
      currentFilterModel.filterType === 'agTextColumnFilter'
    ) {
      data = data.filter((row) => textFilter(row, currentFilterModel));
    }
  });
  return data;
}

// ToDo: implement numberFilter and dateFilter if needed
